import { useContext } from 'react'

import CloseIcon from '@/assets/icons/close.inline.svg'
import HamburgerIcon from '@/assets/icons/hamburger.inline.svg'
import { usePreventScroll } from '@/utils/browser'
import { Toggle, ToggleContext } from '@/components/Toggle'
import Menu from './Menu'

const CloseLabel = () => {
  const { isOpen } = useContext(ToggleContext)

  usePreventScroll(isOpen)

  return <CloseIcon />
}

const MobileActions = () => (
  <Toggle
    openLabel={<HamburgerIcon />}
    closeLabel={<CloseLabel />}
    content={<Menu />}
  />
)

export default MobileActions
